import { seoUtmSource } from '@/js/constants/seo-variables'
import { UTM } from '@/js/enums/utm'
import { transformPathName, transformSlug } from '@/js/helpers/transform-slug'
import { getUtmTaxonomy } from '@/js/helpers/get-utm-taxonomy'

interface Rule {
  hrefIncludes?: string[]
  classIncludes?: string[]
  custom?: (a: HTMLAnchorElement, parent: HTMLElement) => boolean
}

interface UtmConfig {
  parentSelector?: string
  buttonSelector?: string
  rules?: Rule
  utmTags?: UTM[]
  utmCampaign?: string
  clearExistingUtms?: boolean
}

const quizElement = document.getElementById('quiz-link')
const quizUrl = quizElement?.getAttribute('value') || ''
const mainUrl = new URL(window.location.href)
const utmMedium = transformPathName(mainUrl.pathname) || 'main'
const utmTaxonomy = getUtmTaxonomy()

const applyUtm = (config: UtmConfig): void => {
  const parentSelector = config.parentSelector ?? 'section'
  const btnSelector = config.buttonSelector ?? 'a'
  const { hrefIncludes = [], classIncludes = [], custom = null } = config.rules ?? {}

  document.querySelectorAll<HTMLElement>(parentSelector).forEach(parent => {
    const allButtons = Array.from(parent.querySelectorAll<HTMLAnchorElement>(btnSelector))
    const buttons = allButtons.filter(button => {
      const passHref = hrefIncludes.length === 0
        ? true
        : hrefIncludes.some(rule => rule && button.href.includes(rule))

      const passClass = classIncludes.length === 0
        ? true
        : classIncludes.some(rule => rule && button.classList.contains(rule))

      const passCustom = custom ? custom(button, parent) : true

      return passHref && passClass && passCustom
    })

    if (buttons.length === 0) return

    const utmCampaign = config.utmCampaign ?? (transformSlug(parent.className) || 'block')

    buttons.forEach((button, idx) => {
      const buttonText = button.textContent?.trim() || 'button'
      const utmContent = `${transformSlug(buttonText)}_${idx + 1}`

      const url = new URL(button.href)

      if (config.clearExistingUtms) {
        Array.from(url.searchParams.keys())
          .filter(query => query.toLowerCase().startsWith('utm_'))
          .forEach(utm => url.searchParams.delete(utm))
      }
      const defaultUtms: Partial<Record<UTM, string>> = {
        [UTM.UTM_SOURCE]: seoUtmSource,
        [UTM.UTM_MEDIUM]: utmMedium,
        [UTM.UTM_CAMPAIGN]: utmCampaign,
        [UTM.UTM_CONTENT]: utmContent,
        [UTM.UTM_TAXONOMY]: utmTaxonomy
      }

      const activeTags = (config.utmTags && config.utmTags.length > 0)
        ? new Set<UTM>(config.utmTags)
        : new Set<UTM>(Object.keys(defaultUtms) as UTM[])

      for (const utm of Object.keys(defaultUtms) as UTM[]) {
        if (activeTags.has(utm)) {
          url.searchParams.set(utm, defaultUtms[utm]!)
        }
      }

      button.href = url.toString()
    })
  })
}
const configs: UtmConfig[] = [
  {
    parentSelector: 'section',
    buttonSelector: 'a',
    rules: {
      hrefIncludes: [quizUrl],
      classIncludes: ['btn']
    },
    clearExistingUtms: true
  },
  {
    parentSelector: '.banner-wide',
    buttonSelector: 'a',
    rules: {
      hrefIncludes: [quizUrl],
      classIncludes: ['btn']
    },
    clearExistingUtms: true
  },
  {
    parentSelector: '.result-popup',
    buttonSelector: 'a',
    rules: {
      classIncludes: ['btn']
    },
    clearExistingUtms: true
  },
  {
    parentSelector: '#tests-fact__wrapper',
    buttonSelector: 'a',
    rules: {
      hrefIncludes: [quizUrl],
      classIncludes: ['btn']
    },
    utmCampaign: 'test_result',
    clearExistingUtms: true
  }
]

configs.forEach(applyUtm)
